<template>
  <div class="mb-4 p-3">
    <div class="row align-items-center">
      <div class="col-4 m-0">
        <div class="avatar-upload">
          <div class="avatar-edit">
            <input 
              type='file'
              id="imageCreateUpload"
              accept=".png, .jpg, .jpeg"
              @change="onAvatarChange"
            />
            <label for="imageCreateUpload"><i class="uil uil-pen"></i>  </label>
          </div>
          <div class="avatar-preview" style="height:auto; width:auto; aspect-ratio: 1 / 1;">
            <img
              ref="imageCreateUploadpreview"
              class="avatar-lg rounded-lg "
              alt
              style="object-fit: cover;"
            />
          </div>
        </div>
      </div>
      <div class="col-xl-8 col-lg-12">
        <TextField 
          :placeholder="$t('brand.form.name.placeholder')"
          :label="$t('brand.form.name.label')"
          v-model="model.name"
          :error="$v.model.name.$error"
          :errorMessage="$v.model.name.errorMessage"
        />
        <textarea
          class="form-control" 
          name="remarks"
          :placeholder="$t('brand.form.remarks.placeholder')"
          rows="5"
          v-model="model.remarks"
        />
 
      </div>
    </div>
   
  </div>
</template>

<script>
import TextField from '@components/form2/textfield.vue'
import { required } from 'vuelidate/lib/validators'
import  FormMixin from '@mixins/form'

export default {
  mixins: [ FormMixin ],
  components:{
    TextField
  },
  data () {
    return {
      model:{
        name: '',
        remarks: '',
        file: ''
      }
    }
  },
  validations: {
    model:{
      name: { required },
    }
  },
  methods: {
    onAvatarChange(e) {
      let file = e.target.files[0]
      this.model.file = file
      this.$refs.imageCreateUploadpreview.src = URL.createObjectURL(file)
    },
    removeImage() {
      this.$refs.imageCreateUploadpreview.src = ''
    }
  },
  mounted(){
    this.$refs.imageCreateUploadpreview.src = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973461_960_720.png';
  },
}
</script>

<style lang="scss">
  .image_background {
    background: rgb(240, 240, 240);
  }
</style>